import { createAction } from "@reduxjs/toolkit";

const setCurrentMission = createAction("mission/set");

export { setCurrentMission };
